module.exports = __webpack_public_path__ + "img/settings.b2bd8c49.svg";